import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, AutomationInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AutomationsRouterService } from '../../../../shared/automations-router.service';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { buildActivityUrl } from '../create-crm-note';

@Injectable({ providedIn: 'root' })
export class CreateCrmCallActivityService extends AutomationDisplayService {
  constructor(
    protected readonly translateService: TranslateService,
    private readonly router: AutomationsRouterService,
  ) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(
    namespace: string,
    activity: ActivityInterface,
    automation: AutomationInterface,
  ): ActivityTableEntry {
    const activityData = activity?.activityData ? JSON.parse(activity.activityData) : {};
    let activityString: Observable<string> = this.translateService.stream(
      'AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.ACTIVITY',
    );
    if (activityData.company_id || activityData.contact_id) {
      //We didn't have contact or company ids returned originally so we need to support that use case still
      const activityUrl = buildActivityUrl(activityData.activity_id, activityData.company_id, activityData.contact_id);
      activityString = this.router.applyRoutePrefix(activityUrl).pipe(
        take(1),
        map((activityUrl) =>
          this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.ACTIVITY_LINK', {
            url: activityUrl,
          }),
        ),
      );
    }

    return this.tableEntry(activityString, this.getDefaultStepColumnBody(namespace, activity.workflowStep, automation));
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.CREATE_CALL_ACTIVITY.ACTION'),
      this.noValidationErrorsDetected(),
    );
  }
}
